package ai.wagemix.net.models

import com.fsryan.foundation.models.FSStringEnumerated
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport

@OptIn(ExperimentalJsExport::class)
@JsExport
enum class WMBadge(val level: Int, override val stringValue: String): FSStringEnumerated {
    None(-1, "none"),
    Bronze(0, "bronze"),
    Silver(10, "silver"),
    Gold(20, "gold"),
    Platinum(30, "platinum"),
    Diamond(40, "diamond"),
}